// Le rapport de diagnostic est fabrique par le serveur.
//
// Il l'etait auparavant dans le navigateur, par trois composants React qui
// avaient chacun leur mise en page — et qui avaient deja diverge entre eux.
// Le document est desormais le meme quel que soit l'ecran d'ou on le demande.
//
// Le back-office passe par sa propre route : elle sert le meme document, mais
// sans la porte du paiement, l'equipe devant pouvoir relire un rapport pour
// repondre a une question. Les droits y sont tenus par la table des zones.

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function entetes() {
  const jeton = localStorage.getItem('asso_acc_token');
  return jeton ? { Authorization: `Bearer ${jeton}` } : {};
}

function nomPropose(reponse, secours) {
  const entete = reponse.headers.get('Content-Disposition') || '';
  const trouve = /filename="?([^"]+)"?/.exec(entete);
  return trouve ? trouve[1] : secours;
}

async function messageDErreur(reponse) {
  try {
    const donnees = await reponse.json();
    if (donnees && donnees.error) return donnees.error;
    if (donnees && donnees.detail) return donnees.detail;
  } catch {
    // Reponse non JSON : on retombe sur le code HTTP.
  }
  if (reponse.status === 401 || reponse.status === 403) {
    return "Vous n’avez pas accès aux diagnostics.";
  }
  if (reponse.status === 404) return 'Ce diagnostic est introuvable.';
  return 'Le rapport n’a pas pu être généré. Réessayez dans un instant.';
}

/** Telecharge le rapport d'un diagnostic. Leve une erreur portee par le serveur. */
export async function telechargerRapport(diagnosticId) {
  const reponse = await fetch(`${API_BASE}/diagnostics/${diagnosticId}/rapport/`,
                              { headers: entetes() });
  if (!reponse.ok) throw new Error(await messageDErreur(reponse));

  const blob = await reponse.blob();
  const url = window.URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nomPropose(reponse, `diagnostic-${diagnosticId}.pdf`);
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * L'apercu : les MEMES octets, affiches au lieu d'etre enregistres.
 *
 * On passe par une URL d'objet plutot que par l'adresse de la route, parce
 * qu'un <iframe> ne porte pas l'en-tete d'authentification. Penser a liberer
 * l'URL rendue quand l'apercu se ferme.
 */
export async function apercuRapport(diagnosticId) {
  const reponse = await fetch(`${API_BASE}/diagnostics/${diagnosticId}/rapport/?apercu=1`,
                              { headers: entetes() });
  if (!reponse.ok) throw new Error(await messageDErreur(reponse));
  return window.URL.createObjectURL(await reponse.blob());
}
